import React from 'react'
import FirstWelcome from '../Components/FirstWelcome/FirstWelcome'

const FirstWelcomeView = () => {
  return (
    <div>
        <FirstWelcome/>
    </div>
  )
}

export default FirstWelcomeView